import React, { useEffect, useState } from "react";
import Main from "../../components/layout/Main";
import { useParams, useNavigate } from "react-router-dom";

// ------------ Context ------------
import { useTournament } from "../../context/TournamentContext";
import { Severty, ShowToast } from "../../helper/toast";
import { Button } from "antd";

const CreateBrackets = () => {
  const [teams, setTeams] = useState([]);
  const [teamName, setTeamName] = useState();
  const [teamImages, setTeamImages] = useState({});
  const navigate = useNavigate();
  const { id } = useParams();

  // -------- Context Functions ---------
  const { loadTeams, switchPlayers, updateTeam, generateBracket } =
    useTournament();

  // ----------Handlers----------
  const fetchTeams = async () => {
    try {
      const response = await loadTeams(id);
      setTeams(response.data.data.teams);
    } catch (error) {
      console.error("Error fetching teams:", error);
    }
  };

  const handleSave = async (teamId) => {
    const formData = new FormData();
    formData.append("tournamentId", id);
    formData.append("teamId", teamId);
    if (teamName === undefined) {
      formData.append("teamName", "");
    } else {
      formData.append("teamName", teamName);
    }
    // if (teamImage) formData.append("files", teamImage);
    if (teamImages[teamId]) {
      formData.append("image", teamImages[teamId]);
    }
    try {
      const response = await updateTeam(formData);
      console.log("response-->", response);
      if (response.status === 200) {
        ShowToast(response.data.message, Severty.SUCCESS);
      }
    } catch (error) {
      console.error(error);
      alert("Error saving team!");
    }
  };

  const handleGenerateBracket = async () => {
    try {
      const response = await generateBracket(id);
      if (response.status === 200) {
        ShowToast(response.data.message, Severty.SUCCESS);
        navigate("/private-tournaments");
      }
    } catch (error) {
      console.log("Error occured while generate bracket", error);
      ShowToast(error?.data || error.message, Severty.ERROR);
    }
  };

  // --------- Use Effects ---------
  useEffect(() => {
    fetchTeams();
  }, [id]);

  return (
    <Main>
      <div className="create-bracket-finalize-div">
        <Button
          className="Fill-button create-bracket-finalize-button"
          onClick={() => handleGenerateBracket()}
        >
          Finalize
        </Button>
      </div>
      <div className="create-bracket-wrapper">
        {teams &&
          teams.map((team, index) => {
            return (
              <div className="create-bracket-card" key={index}>
                {/* Image Upload */}
                <label className="create-bracket-image-upload">
                  <input
                    type="file"
                    accept="image/*"
                    onChange={(e) =>
                      setTeamImages((prev) => ({
                        ...prev,
                        [team.id]: e.target.files[0],
                      }))
                    }
                    style={{ display: "none" }}
                  />
                  <div className="create-bracket-image-circle">
                    {teamImages[team.id] ? (
                      <img
                        src={URL.createObjectURL(teamImages[team.id])}
                        alt="team"
                        className="create-bracket-preview"
                      />
                    ) : team.image ? (
                      <img
                        src={team.image}
                        alt="team"
                        className="create-bracket-preview"
                      />
                    ) : (
                      <span>📷</span>
                    )}
                  </div>
                </label>

                {/* Team Name */}
                <div className="create-bracket-title">Team Name</div>
                <input
                  className="create-bracket-input"
                  placeholder="Enter team name"
                  defaultValue={team.teamName}
                  onChange={(e) => setTeamName(e.target.value)}
                />

                {/* Drag Player Area */}
                <div className="create-bracket-subtitle">Players</div>
                {/* Show members if available */}
                <div className="create-bracket-players-list">
                  {team.members && team.members.length > 0 ? (
                    team.members.map((member) => {
                      return (
                        <div
                          className="player-card"
                          key={member.id}
                          draggable
                          onDragStart={(e) => {
                            e.dataTransfer.setData("playerId", member.id);
                            e.dataTransfer.setData("fromTeamId", team.id);
                          }}
                        >
                          <div className="player-avatar">
                            {member.profilePic ? (
                              <img src={member.profilePic} alt={member.name} />
                            ) : (
                              <span className="player-placeholder">👤</span>
                            )}
                          </div>
                          <div className="player-info">
                            <div className="player-name">{member.name}</div>
                            <div className="player-email">{member.email}</div>
                          </div>
                        </div>
                      );
                    })
                  ) : (
                    <div className="no-player">No players in this team</div>
                  )}
                </div>
                <div
                  className="create-bracket-dropbox"
                  onDragOver={(e) => e.preventDefault()}
                  onDrop={async (e) => {
                    const playerId = e.dataTransfer.getData("playerId");
                    const fromTeamId = e.dataTransfer.getData("fromTeamId");
                    const toTeamId = team.id;

                    if (fromTeamId === toTeamId) return; // no change

                    await switchPlayers({
                      tournamentId: id,
                      playerId,
                      fromTeamId,
                      toTeamId,
                    });

                    fetchTeams();
                  }}
                >
                  Drag player here
                </div>

                {/* Save Button */}
                <button
                  className="create-bracket-save-btn"
                  onClick={() => handleSave(team.id)}
                >
                  Save
                </button>
              </div>
            );
          })}
      </div>
    </Main>
  );
};

export default CreateBrackets;
